import { render, staticRenderFns } from "./branch-view-modal.vue?vue&type=template&id=107693f2&scoped=true&"
import script from "./branch-view-modal.vue?vue&type=script&lang=js&"
export * from "./branch-view-modal.vue?vue&type=script&lang=js&"
import style0 from "./branch-view-modal.vue?vue&type=style&index=0&id=107693f2&lang=scss&scoped=true&"
import style1 from "./branch-view-modal.vue?vue&type=style&index=1&id=107693f2&lang=scss&scoped=true&"
import style2 from "./branch-view-modal.vue?vue&type=style&index=2&id=107693f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107693f2",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QIcon,QImg,QSpinnerIos,QScrollArea,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QIcon,QImg,QSpinnerIos,QScrollArea})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
